import './index.scss'

export default function ArtsTit({titulo}){
    return(
        <div className="main-article-title">
            <h2>{titulo}</h2>
        </div>
    );
}